import FacebookMetaTags from './FacebookMetaTags';

export default FacebookMetaTags;
